module.exports = __webpack_public_path__ + "img/icon_shouye_chayan.a60179b9.png";